<div *ngIf="src=='text'" class="text-holder">
  <div class="brand-lines">
    
    <svg [@animation1]="_animate"  xmlns="http://www.w3.org/2000/svg" class="brand-line brand-line-1">
      <defs>
        <linearGradient  id="giograd1" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color: rgb(216,97,3); stop-opacity: 1;"></stop>
          <stop offset="45%" style="stop-color: rgb(234,16,6); stop-opacity: 1;"></stop>
          <stop offset="100%" style="stop-color: rgb(251,201,55); stop-opacity: 1;"></stop>
        </linearGradient>
      </defs>
      <polygon points="0,3 102,0 102,6" fill="url(#giograd1)"></polygon>
    </svg>
    <svg [@animation2]="_animate" xmlns="http://www.w3.org/2000/svg" class="brand-line brand-line-2">
      <defs>
        <linearGradient  id="giograd2" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color: rgb(216,97,3); stop-opacity: 1;"></stop>
          <stop offset="45%" style="stop-color: rgb(234,16,6); stop-opacity: 1;"></stop>
          <stop offset="100%" style="stop-color: rgb(251,201,55); stop-opacity: 1;"></stop>
        </linearGradient>
      </defs>
      <polygon points="0,3 92,0 92,6" fill="url(#giograd2)"></polygon>
    </svg>
    <svg  [@animation3]="_animate" xmlns="http://www.w3.org/2000/svg" class="brand-line brand-line-3">
      <defs>
        <linearGradient  id="giograd3" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color: rgb(216,97,3); stop-opacity: 1;"></stop>
          <stop offset="45%" style="stop-color: rgb(234,16,6); stop-opacity: 1;"></stop>
          <stop offset="100%" style="stop-color: rgb(251,201,55); stop-opacity: 1;"></stop>
        </linearGradient>
      </defs>
      <polygon points="0,3 82,0 82,6" fill="url(#giograd3)"></polygon>
    </svg>
  </div>

  <div class="brand-name">
    GIOCO
  </div>
  <!-- <div class="entity-type">

    {{entityBrandName}}
  </div> -->
</div>
